<template>
  <v-footer app
  dark
  padless>
    <span>&copy;2020 - {{ new Date().getFullYear() }} <a href="https://jobtotal.com.hk/" class="text-decoration-none ">JobTotal Service Ltd</a> All Rights Reserved.</span>
  </v-footer>
</template>

<script>
// import { getToken } from '@/utils/auth'
export default {
  name: 'BaseFooter',
  mounted () {
    // console.log('debug current token: ')
    // console.log(getToken())
  }
}
</script>
